import { Modal, ModalHeader } from "@joonapp/web-shared"
import { create } from "zustand"

interface ImageModalStore {
  isOpen: boolean
  onOpen: (imageUrl: string, title: string) => void
  imageUrl: string
  title: string
  onClose: () => void
}

const initialState = {
  isOpen: false,
  imageUrl: "",
  title: "",
}

export const useImageModalStore = create<ImageModalStore>((set) => ({
  ...initialState,
  onOpen: (imageUrl, title) => set({ isOpen: true, imageUrl, title }),
  onClose: () => set(initialState),
}))

const ImageModal = () => {
  const { isOpen, imageUrl, title, onClose } = useImageModalStore()

  return (
    <Modal
      mobileFull
      isOpen={isOpen}
      onClose={onClose}
      style={{
        maxWidth: "min(100vw, 1000px)",
      }}
    >
      <ModalHeader title={title} showBorderBottom onClose={onClose} />
      <div className="w-full flex items-center justify-center p-3">
        <img
          src={imageUrl}
          alt="Completion upload"
          className="max-w-full max-h-[calc(100vh-100px)] h-auto w-auto object-contain"
        />
      </div>
    </Modal>
  )
}

export default ImageModal
